// Lodge Config Actions

import LodgeApiClient from '../../../api/clients/LodgeApiClient';
import { EVENT_CATEGORIES, generalAppInsightsTrack } from '../../../utilities/applicationInsights';
import { LODGE_CONFIG_TYPES } from '../../../utilities/constants';
import { updateCurrentLodge } from '../CurrentLodge/currentLodge.actions';
import { getResortLocation } from '../CurrentLodge/currentLodge.selectors';
import lodgeConfigActionTypes from './lodgeConfig.types';

const verifyIfIsEnabled = option => {
  const optionValue = typeof option === 'boolean' ? option : false;
  return optionValue;
};

const verifyPointsMultiplier = option => {
  const optionValue = typeof option === 'number' ? option / 100 : 0.1;
  return optionValue;
};

const transformStringToArray = option => JSON.parse(option);

export const getBeIdMeParameters = () => async (dispatch, getState) => {
  const resortLocation = getResortLocation(getState().currentLodge);
  if (!resortLocation) return; // resort not set yet — avoid calling the API with an empty/null location
  try {
    const configurationClient = new LodgeApiClient();
    const configurationData = await configurationClient.getConfiguration(
      resortLocation,
      LODGE_CONFIG_TYPES.IDME_WIDGET
    );
    dispatch({
      type: lodgeConfigActionTypes.ID_ME_DATA_PARAMETERS,
      idMeParameters: configurationData.data
    });
  } catch (error) {
    console.log(error);
  }
};

export const getDaypassConfigByResort = () => async (dispatch, getState) => {
  const resortLocation = getResortLocation(getState().currentLodge);
  if (!resortLocation) return false; // resort not set yet — skip; hook will retry once updateCurrentLodge runs
  try {
    const configurationClient = new LodgeApiClient();
    const configurationData = await configurationClient.getConfiguration(resortLocation, LODGE_CONFIG_TYPES.DAYPASS);
    dispatch({
      type: lodgeConfigActionTypes.SUCCESS_LODGE_CONFIG_LOADING_DAYPASS,
      daypassTicketLimit: configurationData.data.daypassTicketLimit
    });
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export const getLoyaltyConfigByResort = () => async (dispatch, getState) => {
  const resortLocation = getResortLocation(getState().currentLodge);
  if (!resortLocation) return false; // resort not set yet — skip; hook will retry once updateCurrentLodge runs

  try {
    const configurationClient = new LodgeApiClient();
    const configurationData = await configurationClient.getConfiguration(resortLocation, LODGE_CONFIG_TYPES.LOYALTY);

    dispatch({
      type: lodgeConfigActionTypes.SUCCESS_LODGE_CONFIG_LOADING,
      isLoyaltyEnabled: verifyIfIsEnabled(configurationData.data.isLoyaltyEnabled),
      isInPrimerState: verifyIfIsEnabled(configurationData.data.isInPrimerState),
      isOffersEnabled: verifyIfIsEnabled(configurationData.data.isOffersEnabled),
      loyaltyPointsMultiplier: verifyPointsMultiplier(configurationData.data.loyaltyPointsMultiplier),
      isLoyaltyReferralEnabled: verifyIfIsEnabled(configurationData.data.isLoyaltyReferralEnabled),
      isLoyaltyPointsExpirationOnProfileEnabled: verifyIfIsEnabled(
        configurationData.data.isLoyaltyPointsExpirationOnProfileEnabled
      ),
      loyaltyPointsToEarn: configurationData.data.loyaltyPointsToEarn,
      loyaltyEarnThresholdNights: configurationData.data.loyaltyEarnThresholdNights ?? 2,
      //TODO: This flag will be here until we find a proper lodge config API to hold this case
      isHoldCancelReservationEnabled: verifyIfIsEnabled(configurationData.data.isHoldCancelReservationEnabled)
    });
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};
export const getPlanConfigByResort = () => async (dispatch, getState) => {
  const resortLocation = getResortLocation(getState().currentLodge);
  if (!resortLocation) return false; // resort not set yet — skip; hook will retry once updateCurrentLodge runs

  try {
    const configurationClient = new LodgeApiClient();
    const configurationData = await configurationClient.getConfiguration(resortLocation, LODGE_CONFIG_TYPES.PLAN);

    dispatch({
      type: lodgeConfigActionTypes.SUCCESS_LODGE_CONFIG_LOADING_PLAN,
      config: {
        additionalPersonAmount: configurationData.data.additionalPersonAmount,
        affirmPubKey: configurationData.data.affirmPubKey,
        filters: configurationData.data.filters,
        isFetchRestrictionsEnabled: configurationData.data.isFetchRestrictionsEnabled,
        isHighestRatesEnabled: configurationData.data.isHighestRatesEnabled,
        isRateCalEnabled: configurationData.data.isRateCalEnabled,
        updateSearchFullPageRefresh: configurationData.data.updateSearchFullPageRefresh,
        includeResortFeeInSuitePrice: configurationData.data.includeResortFeeInSuitePrice,
        pricePerWaterPass: configurationData.data.pricePerWaterPass,
        isRoomUnbundledRateWPAvailable: configurationData.data.isRoomUnbundledRateWPAvailable,
        suitePriceIncludedTaxesAndFees: configurationData.data.suitePriceIncludedTaxesAndFees ?? '[]',
        showResortFeeModal: configurationData.data.showResortFeeModal,
        showHighlightBadge: verifyIfIsEnabled(configurationData.data.showHighlightBadge),
        showAffirmBanner: verifyIfIsEnabled(configurationData.data.showAffirmBanner),
        isTaxOnlyMessage: verifyIfIsEnabled(configurationData.data.isTaxOnlyMessage),
        promosForShortMessaging: transformStringToArray(configurationData.data.promosForShortMessaging),
        isSleepUpToCase: verifyIfIsEnabled(configurationData.data.isSleepUpToCase),
        lowestToHighestAttractionPasses: configurationData.data.lowestToHighestAttractionPasses,
        taxesExcluded: configurationData.data.taxesExcluded,
        invertNonMemberRate: verifyIfIsEnabled(configurationData.data.invertNonMemberRate),
        suitePriceWithDecimals: verifyIfIsEnabled(configurationData.data.suitePriceWithDecimals)
      }
    });
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};
export const getCreditPackageConfigByResort = () => async (dispatch, getState) => {
  const resortLocation = getResortLocation(getState().currentLodge);
  if (!resortLocation) return false; // resort not set yet — skip; hook will retry once updateCurrentLodge runs

  try {
    const configurationClient = new LodgeApiClient();
    const configurationData = await configurationClient.getConfiguration(
      resortLocation,
      LODGE_CONFIG_TYPES.CREDIT_PACKAGES
    );

    dispatch({
      type: lodgeConfigActionTypes.SUCCESS_LODGE_CONFIG_LOADING_CREDIT_PACKAGE,
      isDiningPackagesEnhancedUIEnabled: verifyIfIsEnabled(configurationData.data.isDiningPackagesEnhancedUIEnabled),
      showAdventurePassesBeforeAttractionPassesInPreCheckInFlow: verifyIfIsEnabled(
        configurationData.data.showAdventurePassesBeforeAttractionPassesInPreCheckInFlow
      )
    });
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};
export const getCmpConfigByResort = () => async (dispatch, getState) => {
  const resortLocation = getResortLocation(getState().currentLodge);
  if (!resortLocation) return false; // resort not set yet — skip; hook will retry once updateCurrentLodge runs

  try {
    const configurationClient = new LodgeApiClient();
    const configurationData = await configurationClient.getConfiguration(resortLocation, LODGE_CONFIG_TYPES.CMP);

    dispatch({
      type: lodgeConfigActionTypes.SUCCESS_LODGE_CONFIG_LOADING_CMP,
      isDynamicTileEnabled: verifyIfIsEnabled(configurationData.data.isDynamicTileEnabled),
      hideOnlineCheckinText: verifyIfIsEnabled(configurationData.data.hideOnlineCheckinText),
      parkingFeeCallout: verifyIfIsEnabled(configurationData.data?.parkingFeeCallout),
      parkingFeeCalloutTitle: configurationData.data?.parkingFeeCalloutTitle ?? '',
      parkingFeeCalloutDescription: configurationData.data?.parkingFeeCalloutDescription ?? '',
      uffTileEnabled: verifyIfIsEnabled(configurationData.data.uffTileEnabled),
      isCancelReservationEnabled: verifyIfIsEnabled(configurationData.data.isCancelReservationEnabled),
      isManageYourReservationEnabled: verifyIfIsEnabled(configurationData.data.isManageYourReservationEnabled),
      isAddGuestsEnabled: verifyIfIsEnabled(configurationData.data.isAddGuestsEnabled),
      isChangeDatesEnabled: verifyIfIsEnabled(configurationData.data.isChangeDatesEnabled),
      isStaticDaypassEnabled: verifyIfIsEnabled(configurationData.data.isStaticDaypassEnabled),
      lowestToHighestAttractionPasses: configurationData.data.lowestToHighestAttractionPasses,
      printToRedeem: verifyIfIsEnabled(configurationData.data.printToRedeem)
    });
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};
/* ABCD TEST FOR PARKING FEE */
export const getPaymentConfigByResort = () => async (dispatch, getState) => {
  const resortLocation = getResortLocation(getState().currentLodge);
  if (!resortLocation) return false; // resort not set yet — skip; hook will retry once updateCurrentLodge runs

  try {
    const configurationClient = new LodgeApiClient();
    const configurationData = await configurationClient.getConfiguration(resortLocation, LODGE_CONFIG_TYPES.PAYMENT);

    // No usable payload -> we return false as a failed API call.
    if (!configurationData?.data) {
      generalAppInsightsTrack(
        `Empty payment configuration for lodge ${resortLocation}`,
        EVENT_CATEGORIES.paymentAPIError
      );
      return false;
    }

    const paymentData = configurationData.data;
    // Data present but every method off
    if (
      !paymentData.creditEnabled &&
      !paymentData.affirmEnabled &&
      !paymentData.applePayEnabled &&
      !paymentData.googlePayEnabled &&
      !paymentData.payPalEnabled
    ) {
      generalAppInsightsTrack(`All payment methods are disabled`, EVENT_CATEGORIES.paymentMethodsDisabled);
    }

    dispatch({
      type: lodgeConfigActionTypes.SUCCESS_LODGE_CONFIG_LOADING_PAYMENT,
      perNightParkingFee1: paymentData.perNightParkingFee1,
      perNightParkingFee2: paymentData.perNightParkingFee2,
      perNightParkingFee3: paymentData.perNightParkingFee3,
      parkingFeeStartDate: paymentData.parkingFeeStartDate,
      parkingFeeEndDate: paymentData.parkingFeeEndDate,
      creditCardAuthUrl: paymentData.creditCardAuthUrl,
      creditEnabled: verifyIfIsEnabled(paymentData.creditEnabled),
      affirmEnabled: verifyIfIsEnabled(paymentData.affirmEnabled),
      applePayEnabled: verifyIfIsEnabled(paymentData.applePayEnabled),
      googlePayEnabled: verifyIfIsEnabled(paymentData.googlePayEnabled),
      payPalEnabled: verifyIfIsEnabled(paymentData.payPalEnabled),
      isIFrameEnabled: verifyIfIsEnabled(paymentData.isIFrameEnabled),
      amexEnabled: verifyIfIsEnabled(paymentData.isAmexEnabled),
      isSwitchToFlexEnabled: verifyIfIsEnabled(paymentData.isSwitchToFlexEnabled),
      taxAndFeeLabels: paymentData.taxAndFeeLabels,
      hideParkingFeeForBirthday: verifyIfIsEnabled(paymentData.hideParkingFeeForBirthday)
    });
    return true;
  } catch (error) {
    generalAppInsightsTrack(`${error.message} with lodge ${resortLocation}`, EVENT_CATEGORIES.paymentAPIError);
    console.log(error);
    return false;
  }
};
/* ABCD TEST FOR PARKING FEE */
export const getLeadGenConfigByResort = () => async (dispatch, getState) => {
  const resortLocation = getResortLocation(getState().currentLodge);
  if (!resortLocation) return false; // resort not set yet — skip; hook will retry once updateCurrentLodge runs

  try {
    const configurationClient = new LodgeApiClient();
    const configurationData = await configurationClient.getConfiguration(resortLocation, LODGE_CONFIG_TYPES.LEAD_GEN);

    dispatch({
      type: lodgeConfigActionTypes.SUCCESS_LODGE_CONFIG_LOADING_LEADGEN,
      shouldLeadGenPop: configurationData.data.shouldLeadGenPop
    });
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};
export const resetLodgeConfig = () => async dispatch => {
  dispatch(updateCurrentLodge());
  dispatch({ type: lodgeConfigActionTypes.RESET_LODGE_CONFIG });
};
export const getCartConfigByResort = () => async (dispatch, getState) => {
  const resortLocation = getResortLocation(getState().currentLodge);
  if (!resortLocation) return false; // resort not set yet — skip; hook will retry once updateCurrentLodge runs

  try {
    const configurationClient = new LodgeApiClient();
    const configurationData = await configurationClient.getConfiguration(resortLocation, LODGE_CONFIG_TYPES.CART);

    dispatch({
      type: lodgeConfigActionTypes.SUCCESS_LODGE_CONFIG_LOADING_CART,
      config: {
        isCartActive: configurationData.data.isCartActive
      }
    });
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};
export const getBookingWidgetConfigByResort = () => async (dispatch, getState) => {
  const resortLocation = getResortLocation(getState().currentLodge);
  if (!resortLocation) return false; // resort not set yet — skip; hook will retry once updateCurrentLodge runs

  try {
    const configurationClient = new LodgeApiClient();
    const configurationData = await configurationClient.getConfiguration(
      resortLocation,
      LODGE_CONFIG_TYPES.BOOKING_WIDGET
    );

    dispatch({
      type: lodgeConfigActionTypes.SUCCESS_LODGE_CONFIG_LOADING_BOOKING_WIDGET,
      beginReservationsDate: configurationData.data.beginReservationsDate,
      maxOccupancy: configurationData.data.maxOccupancy,
      stickyBottomBookingWidget: verifyIfIsEnabled(configurationData.data.stickyBottomBookingWidget),
      ageThreshold: configurationData.data.ageThreshold,
      isLowestRatesRestrictionsEnabled: verifyIfIsEnabled(configurationData.data.isLowestRatesRestrictionsEnabled),
      hiddenOfferPrefixes: transformStringToArray(configurationData.data.hiddenOfferPrefixes),
      isWileyAIEnabled: verifyIfIsEnabled(configurationData.data.isWileyAIEnabled),
      isOtpLoginEnabled: verifyIfIsEnabled(configurationData.data.isOtpLoginEnabled)
    });
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export const getPartyBookingWidgetConfigByResort = () => async (dispatch, getState) => {
  const resortLocation = getResortLocation(getState().currentLodge);
  if (!resortLocation) return false; // resort not set yet — skip; hook will retry once updateCurrentLodge runs

  try {
    const configurationClient = new LodgeApiClient();
    const configurationData = await configurationClient.getConfiguration(
      resortLocation,
      LODGE_CONFIG_TYPES.BDAY_BOOKING_WIDGET
    );

    dispatch({
      type: lodgeConfigActionTypes.SUCCESS_LODGE_CONFIG_LOADING_PARTY_BOOKING_WIDGET,
      isBdayBookingWidgetActive: configurationData.data.isBdayBookingWidgetActive,
      birthdayPartyInclusionList: transformStringToArray(configurationData.data.birthdayPartyInclusionList) ?? [],
      partyKidsPerAdultRatio: configurationData.data.kidsPerAdultRatio,
      partyMaxGuestCount: configurationData.data.maxGuestCount,
      minimumBookingDaysRestriction: configurationData.data.minimumBookingDaysRestriction,
      maximumBookingDaysRestriction: configurationData.data.maximumBookingDaysRestriction,
      maxSpectatorsCount: configurationData.data.maxSpectatorsCount ?? 5
    });
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export const getProfilePageConfigResort = () => async (dispatch, getState) => {
  const resortLocation = getResortLocation(getState().currentLodge);
  if (!resortLocation) return false; // resort not set yet — skip; hook will retry once updateCurrentLodge runs

  try {
    const configurationClient = new LodgeApiClient();
    const configurationData = await configurationClient.getConfiguration(resortLocation, LODGE_CONFIG_TYPES.PROFILE);

    if (configurationData?.data?.maxSpectatorsCount) {
      dispatch({
        type: lodgeConfigActionTypes.SUCCESS_LODGE_CONFIG_LOADING_PROFILE,
        packMembersLimit: configurationData.data.maxSpectatorsCount
      });
    }
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};
